'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tabs = require('../Tabs/Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Select = require('../Select/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content');

var _Content2 = _interopRequireDefault(_Content);

var _SelectContainer = require('./components/SelectContainer');

var _SelectContainer2 = _interopRequireDefault(_SelectContainer);

var _schedules = require('./schedules/schedules');

var _schedules2 = _interopRequireDefault(_schedules);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Schedules


var Scheduler = function (_Component) {
  _inherits(Scheduler, _Component);

  function Scheduler() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scheduler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scheduler.__proto__ || Object.getPrototypeOf(Scheduler)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      schedule: _schedules2.default[0],
      Option: _schedules2.default[0].options[0]
    }, _this.tabs = function () {
      return [].concat(_toConsumableArray(_schedules2.default)).map(function (_ref2) {
        var key = _ref2.key,
            label = _ref2.label;
        return {
          id: key,
          label: label
        };
      });
    }, _this.onTabChange = function (tab) {
      var schedule = [].concat(_toConsumableArray(_schedules2.default)).find(function (_ref3) {
        var key = _ref3.key;
        return key === tab;
      });
      if (!schedule || !schedule.options.length) return;
      var state = {
        schedule: schedule
      };
      state.Option = schedule.options[0];

      _this.setState(state);

      _this.props.onChange(null);
    }, _this.options = function () {
      return [].concat(_toConsumableArray(_this.state.schedule.options)).map(function (_ref4) {
        var key = _ref4.key,
            label = _ref4.label;
        return {
          value: key,
          label: label
        };
      });
    }, _this.onOption = function (option) {
      var Option = [].concat(_toConsumableArray(_this.state.schedule.options)).find(function (_ref5) {
        var key = _ref5.key;
        return key === option;
      });
      if (!Option) return;

      _this.setState({
        Option: Option
      });

      _this.props.onChange(null);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scheduler, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          onChange = _props.onChange;
      var _state = this.state,
          schedule = _state.schedule,
          Option = _state.Option;
      return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_Tabs2.default, {
        tabs: this.tabs(),
        tab: schedule.key,
        onChange: this.onTabChange
      }), _react2.default.createElement(_Content2.default, null, schedule.options.length > 1 && _react2.default.createElement(_SelectContainer2.default, null, _react2.default.createElement(_Select2.default, {
        value: Option.key,
        options: this.options(),
        onChange: this.onOption,
        notFilterable: true
      }, 'Options')), _react2.default.createElement(Option, {
        disabled: disabled,
        onChange: onChange
      })));
    }
  }]);

  return Scheduler;
}(_react.Component);

Scheduler.propTypes = {
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired
};
exports.default = Scheduler;